@if (isFormLoading) {
  <app-widget-loader></app-widget-loader>
}

@if (!isFormLoading) {
  <table class="table">
    <tbody>
      <tr>
        <td>{{ 'Site Name' | translate }}</td>
        <td>{{observation?.siteName}}</td>
      </tr>
      <tr>
        <td>{{ 'Date&Time' | translate }}</td>
        <td>{{$safeNavigationMigration(observation?.utc) | dateFormat}}</td>
      </tr>
      @for (o of observations; track trackByIndex($index)) {
        <tr>
          <td>{{o.parameter}} [{{o.unit}}]</td>
          <td>{{o.rawConcentration}}</td>
        </tr>
      }
      <tr>
        <td>{{ 'Latitude [°]' | translate }}</td>
        <td>{{observation?.latitude}}</td>
      </tr>
      <tr>
        <td>{{ 'Longitude [°]' | translate }}</td>
        <td>{{observation?.longitude}}</td>
      </tr>
    </tbody>
  </table>
}

<div class="overflow-hidden justify-content-end" [ngClass]="isFormLoading ? 'd-none': 'd-flex'">
  <button class="btn main-btn" mat-button (click)="assign()" [class.button-spinner]="isLoading"
    [disabled]="isFormLoading || isLoading || !(organizationLevelId$ | async)">
    {{ 'Assign' | translate }}
  </button>
</div>
